import * as React from 'react';
import {useFormikContext} from 'formik';
import styled from 'styled-components';
import {Title as ContainerTitle} from './Plan';
import RadioCard, {Container as RadioCardContainer} from './RadioCard';
import RangeStorage from './RangeStorage';
import {PaymentPeriod, TariffsValues} from "../types";
import {setLocalStorageTariffs} from "../helpers";
import {
  Container,
  ContainerDescription,
  getDiscount,
  getPaymentPeriodValue, Groups,
  GroupTitle,
  Separator
} from "./Constructor";
import Footer from "./Footer";

const Wrapper = styled.div`
  display: grid;
  gap: 17px;
  
  ${RadioCardContainer} {
    min-height: 98px;
  }
`;

const Group = styled.div`
  
`;

const GroupContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
`;

const FooterTitle = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 10px;
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0.01em;
`;

const Description = styled.div`
  display: grid;
  gap: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;
  text-align: left;
`

/**
 * render tariffs constructor component
 * @constructor
 */
export default function MonthEnd(): React.ReactElement {
  const {values, setFieldValue} = useFormikContext<Partial<TariffsValues>>();

  React.useEffect(() => {
    if (values.selected) {
      setLocalStorageTariffs(values.selected)
    }
  }, [values.selected])

  const paymentPeriod = values.selected?.paymentPeriod;
  const prices = values.selected?.prices;

  /**
   * payment period item click handler
   * @param {PaymentPeriod} period
   * @constructor
   */
  function onPaymentPeriodClick(period: PaymentPeriod) {
    setFieldValue('selected.paymentPeriod', period);
  }

  React.useEffect(() => {
    const period = values.selected?.paymentPeriod;

    const priceForStorage = prices?.storage || 0;
    const priceForStudents= prices?.students || 0;

    const fullPrice = priceForStorage + priceForStudents;

    const discountValue = fullPrice * getDiscount(period) / 100;

    const value = (fullPrice - discountValue) * getPaymentPeriodValue(period);

    setFieldValue('selected.prices.full', Math.round(value));

  }, [
    prices?.students,
    prices?.storage,
    paymentPeriod
  ])

  return (
    <Wrapper>
      <Container>
        <ContainerTitle>Конструктор тарифа</ContainerTitle>
        <ContainerDescription>
          Все функции доступны.
        </ContainerDescription>
        <Groups>
          <div>
            <GroupContent>
              <RadioCard
                label={'в конце месяца'}
                discountLabel={'Без скидок'}
                checked={paymentPeriod === PaymentPeriod.Month}
                onClick={() => onPaymentPeriodClick(PaymentPeriod.Month)}
              />
            </GroupContent>
          </div>
          <Description>
            <div>
              Количество участников не ограничено.
              <br/>
              Финальная стоимость рассчитывается по базовому тарифу.
              (тут тарифах линк на страницу с базовыми тарифами)
              <br/>
              Оплата начисляется 1-го числа каждого месяца.
            </div>
            <div>
              ⚠️ Важно: при неоплате в течение 5 дней,
              все курсы автоматически снимутся с публикации, а доступ участников
              к текущим будет приостановлен.
            </div>
          </Description>
        </Groups>
      </Container>
      <Container>
        <Groups>
          <Group>
            <GroupTitle>Файловое хранилище:</GroupTitle>
            <RangeStorage />
          </Group>
          <Separator />

          <FooterTitle>
            <span>Всего к оплате:</span>
            <span>{prices?.full} ₽</span>
          </FooterTitle>

          <Footer />
        </Groups>
      </Container>
    </Wrapper>
  );
}